/* globals window localStorage */

import React from 'react';
import 'antd/dist/antd.css';
import { Layout, Typography, Button as AntdButton, Spin, Icon } from 'antd';
import './Chat.css';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import { Client } from '@twilio/conversations';
import update from 'immutability-helper';
import { apiGet, apiPost, apiPut } from '../brainApi';
import Conversation from './Conversation';
import ConversationList from './ConversationList';
import HeaderItem from './HeaderItem';
import ConversationDetails from './ConversationDetails';
import ConversationListHeader from './ConversationListHeader';
import MessageInputField from './MessageInputField';
import ProfileImage from '../tabs/customer/ProfileImage';

const { Content, Sider, Header } = Layout;
const { Text } = Typography;

class Zipchat extends React.Component {
  constructor(props) {
    super(props);

    const employee = localStorage.getItem('employee')
      ? localStorage.getItem('employee')
      : null;

    const email = JSON.parse(employee)
      ? JSON.parse(employee).email_address
      : '';

    this.state = {
      email,
      token: null,
      connectionStatus: null,
      conversationComponents: [],
      selectedConversationSid: null,
      snackbarOpen: false,
      snackbarMessage: '',
      snackbarSeverity: 'error',
      isConversationLoading: false,
      isListLoading: false,
      userTyping: {},
      isDetailsPanelOpen: true,
      isNewConversationOpen: false,
    };
  }

  componentWillMount = () => {
    this.getToken(this.initChat);
  };

  getToken = (callback) => {
    apiGet('/twilio/chat-token').then((res) => {
      if (res.Status === 'Success') {
        this.setState({ token: res.Token }, () => callback(res.Token));
      } else {
        this.setSnackbar(res.Message);
      }
    });
  };

  initChat = async () => {
    const { token } = this.state;
    this.chatClient = new Client(token);
    this.chatClient.on('connectionStateChanged', (state) => {
      this.setState({ connectionStatus: state });
      switch (state) {
        case 'connecting':
          console.log('Connecting');
          break;
        case 'connected':
          console.log('Connected');
          break;
        case 'disconnecting':
          console.log('Disconnecting');
          break;
        case 'disconnected':
          console.log('Disconnected');
          window.alert(
            'You have been disconnected from the chat. Please refresh to receive new messages.',
          );
          break;
        default:
          console.log('Denied');
          window.alert('Failed to connect. Refresh to try again.');
      }
    });

    this.chatClient.on('conversationJoined', async (joinedConversation) => {
      this.setState({ isListLoading: true });
      joinedConversation
        .getMessages()
        .then(async (messagePaginator) => {
          const lastMessage =
            messagePaginator.items.length > 0
              ? messagePaginator.items[
                  messagePaginator?.items?.length - 1
                    ? messagePaginator?.items?.length - 1
                    : 0
                ]
              : {};

          // Add joined conversation to state
          this.setState(({ conversationComponents }) => ({
            conversationComponents: [
              ...conversationComponents,
              { baseConversation: joinedConversation, lastMessage },
            ],
          }));
          this.setState({ isListLoading: false });
          // Listen for new messages and update state
          joinedConversation.on('messageAdded', (message) => {
            this.setLastMessage(joinedConversation, message);
          });
          // Determine if conversation includes a customer and update state. Update again if members change.
          joinedConversation.on('memberJoined', (member) => {
            this.updateMembers('add', joinedConversation, member);
          });
          joinedConversation.on('memberLeft', (member) => {
            this.updateMembers('remove', joinedConversation, member);
          });
          // Listen for typing to display indicators
          joinedConversation.on('typingStarted', (member) => {
            this.setState({ userTyping: member });
          });
          joinedConversation.on('typingEnded', () => {
            this.setState({ userTyping: {} });
          });
        })
        .catch((err) => {
          console.error("Couldn't fetch messages IMPLEMENT RETRY", err);
          this.setState({ isListLoading: false });
        });
    });

    // Any time a conversation's attributes or metadata change, update state
    this.chatClient.on('conversationUpdated', (updatedConversation) => {
      const { conversationComponents } = this.state;
      const foundConvoIndex = conversationComponents.findIndex(
        (convoComponent) =>
          convoComponent.baseConversation.sid ===
          updatedConversation.conversation.sid,
      );
      if (foundConvoIndex !== -1) {
        const updatedConversations = update(conversationComponents, {
          [foundConvoIndex]: {
            baseConversation: { $set: updatedConversation.conversation },
          },
        });
        this.setState({ conversationComponents: updatedConversations });
      }
    });

    this.chatClient.on('conversationLeft', (leftConversation) => {
      this.setState(({ conversationComponents }) => ({
        conversationComponents: [
          ...conversationComponents.filter(
            (elem) => elem.baseConversation !== leftConversation,
          ),
        ],
      }));
    });

    this.chatClient.on('tokenAboutToExpire', () => {
      this.getToken((newToken) => this.chatClient.updateToken(newToken));
    });
  };

  setLastMessage = (conversation, message) => {
    const { conversationComponents } = this.state;
    const foundConvoIndex = conversationComponents.findIndex(
      (convoComponent) =>
        convoComponent.baseConversation.sid === conversation.sid,
    );
    const updatedConversationComponents = update(conversationComponents, {
      [foundConvoIndex]: { lastMessage: { $set: message } },
    });
    this.setState({ conversationComponents: updatedConversationComponents });
  };

  updateMembers = (updateType, conversation, member) => {
    const { conversationComponents } = this.state;
    const foundConvoIndex = conversationComponents.findIndex(
      (convoComponent) =>
        convoComponent.baseConversation.sid === conversation.sid,
    );
    let updatedConversationComponents;
    if (updateType === 'add') {
      updatedConversationComponents = update(conversationComponents, {
        [foundConvoIndex]: { members: { $push: [member] } },
      });
    } else {
      const foundMemberIndex = conversationComponents[
        foundConvoIndex
      ].members.findIndex((m) => m.state.identity === member.identity);
      updatedConversationComponents = update(conversationComponents, {
        [foundConvoIndex]: { members: { $splice: [[foundMemberIndex, 1]] } },
      });
    }
    this.setState({ conversationComponents: updatedConversationComponents });
  };

  handleTicketUpdate = (e, conversationSid, email, status) => {
    const params = {
      status,
      changedBy: email,
    };
    e.stopPropagation();
    apiPut(`/twilio/conversation/${conversationSid}/ticket`, params)
      .then((response) => {
        if (response.Status === 'Success') {
          this.setSnackbar('Status updated!', 'success');
        } else
          this.setSnackbar(
            `Status failed to update. Error: ${response.Message}`,
          );
      })
      .catch((error) => {
        console.log(error);
        this.setSnackbar(`Status failed to update. Error: ${error}`);
      });
  };

  findConversationByCustomerOrLead = (customerId = null, leadId = null) => {
    // Join existing conversation or create new
    this.setIsListLoading(true);
    apiPost('/twilio/conversation', {
      customer_id: customerId,
      lead_id: leadId,
    })
      .then((res) => {
        if (res.Status === 'Success') {
          if (res.Message) {
            this.setSnackbar(res.Message, 'warning');
          }
          const foundConversationSid = res.Data;
          this.setState({
            selectedConversationSid: foundConversationSid,
          });
        } else {
          this.setSnackbar(res.Message);
        }
        this.setIsListLoading(false);
        this.setIsConversationLoading(false);
      })
      .catch((error) => {
        console.log(error);
        this.setSnackbar(`Error: ${error}`);
        this.setIsConversationLoading(false);
        this.setIsListLoading(false);
      });
  };

  setSelectedConversationSid = (conversationSid) => {
    this.setState({
      selectedConversationSid: conversationSid,
      isNewConversationOpen: false,
    });
  };

  setSnackbar = (message, severity = 'error') => {
    this.setState({
      snackbarMessage: message,
      snackbarOpen: true,
      snackbarSeverity: severity,
    });
  };

  setIsConversationLoading = (bool) => {
    this.setState({ isConversationLoading: bool });
  };

  setIsListLoading = (bool) => {
    this.setState({ isListLoading: bool });
  };

  setIsNewConversationOpen = (bool) => {
    this.setState({ isNewConversationOpen: bool });
  };

  render() {
    const {
      conversationComponents,
      selectedConversationSid,
      connectionStatus,
      email,
      snackbarOpen,
      snackbarMessage,
      snackbarSeverity,
      isConversationLoading,
      isListLoading,
      userTyping,
      isDetailsPanelOpen,
      isNewConversationOpen,
    } = this.state;

    const selectedConversationComponent = conversationComponents.find(
      (elem) => elem?.baseConversation?.sid === selectedConversationSid,
    );

    const selectedConversation =
      selectedConversationComponent?.baseConversation;

    const ticketStatus =
      selectedConversation?.channelState.attributes?.ticket_history?.[
        selectedConversation.channelState.attributes.ticket_history.length - 1
      ];
    const isResolved = ticketStatus?.status === 'Resolved';

    let conversationContent;
    if (selectedConversation) {
      conversationContent = (
        <Conversation
          channelProxy={selectedConversation}
          myIdentity={email}
          userTyping={userTyping}
          setSnackbar={this.setSnackbar}
        />
      );
    } else if (connectionStatus !== 'connected') {
      conversationContent = (
        <div className="center">
          <Spin size="large" />
        </div>
      );
    } else if (isNewConversationOpen) {
      conversationContent = (
        <div
          style={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
          }}
        >
          <MessageInputField loadingState="Pending conversation selection" />
        </div>
      );
    } else {
      conversationContent = (
        <div className="center">
          <Text>Select a conversation</Text>
        </div>
      );
    }
    if (!isNewConversationOpen && conversationComponents.length === 0) {
      conversationContent = (
        <div className="center">
          <Text>No active conversations</Text>
        </div>
      );
    }

    return (
      <>
        <div className="zipchat-app">
          <Spin
            size="large"
            tip="Loading conversation..."
            spinning={isConversationLoading}
          >
            <div>
              <Layout className="chat-window-container">
                <Layout className="left-panel">
                  <Header className="left-panel-header">
                    <HeaderItem>
                      <ConversationListHeader
                        isListLoading={isListLoading}
                        findConversationByCustomerOrLead={
                          this.findConversationByCustomerOrLead
                        }
                      />
                    </HeaderItem>
                  </Header>
                  <Content>
                    <ConversationList
                      isListLoading={isListLoading}
                      email={email}
                      conversationComponents={conversationComponents}
                      selectedConversationSid={selectedConversationSid}
                      handleTicketUpdate={this.handleTicketUpdate}
                      onChannelClick={(item, callback = () => {}) => {
                        this.setState({
                          selectedConversationSid: item.sid,
                          isNewConversationOpen: false,
                        });

                        apiPut(
                          `/twilio/conversation/${item.sid}/read-receipt`,
                          { markAsUnread: false },
                        ).then(callback);
                      }}
                    />
                  </Content>
                </Layout>

                <Layout className="center-panel">
                  <Header className="center-panel-header">
                    <>
                      {selectedConversation && (
                        <>
                          <div className="conversation-friendly-name">
                            <ProfileImage
                              name={selectedConversation.friendlyName}
                              width="40"
                              height="40"
                            />
                            <Text
                              ellipsis
                              strong
                              style={{ color: '#000', marginLeft: '10px' }}
                            >
                              {selectedConversation.friendlyName ||
                                selectedConversation.sid}
                            </Text>
                          </div>
                          <div className="conversation-actions">
                            <Text>
                              {ticketStatus && (
                                <AntdButton
                                  disabled={isResolved}
                                  style={
                                    isResolved
                                      ? {
                                          color: '#4bb516',
                                          borderColor: '#4bb516',
                                          marginRight: '23px',
                                        }
                                      : {
                                          color: 'inherit',
                                          marginRight: '23px',
                                        }
                                  }
                                  onClick={(e) =>
                                    this.handleTicketUpdate(
                                      e,
                                      selectedConversation.sid,
                                      email,
                                      'Resolved',
                                    )
                                  }
                                >
                                  <Icon
                                    type="check"
                                    style={{
                                      fontSize: '15px',
                                      color: isResolved ? '#4bb516' : 'inherit',
                                    }}
                                  />{' '}
                                  {isResolved ? 'Resolved' : 'Mark as Resolved'}
                                </AntdButton>
                              )}
                            </Text>
                            <Text>
                              <span>
                                <Icon
                                  type="info-circle"
                                  id="details-icon"
                                  onClick={() =>
                                    this.setState({
                                      isDetailsPanelOpen: !isDetailsPanelOpen,
                                    })
                                  }
                                />
                              </span>
                            </Text>
                          </div>
                        </>
                      )}
                    </>
                  </Header>
                  <Content>
                    <div id="SelectedConversation">{conversationContent}</div>
                  </Content>
                </Layout>

                <Sider
                  collapsible
                  collapsed={!selectedConversation || !isDetailsPanelOpen}
                  collapsedWidth={0}
                  className="right-panel ant-list-bordered"
                  width={300}
                  theme="light"
                  trigger={null}
                >
                  {selectedConversation && (
                    <ConversationDetails
                      conversationComponents={conversationComponents}
                      members={selectedConversationComponent.members}
                      selectedConversation={selectedConversation}
                      setError={this.setSnackbar}
                    />
                  )}
                </Sider>
              </Layout>
            </div>
          </Spin>
        </div>
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={5000}
          onClose={() => this.setState({ snackbarOpen: false })}
        >
          <Alert
            onClose={() => this.setState({ snackbarOpen: false })}
            severity={snackbarSeverity}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </>
    );
  }
}

export default Zipchat;
